import { TOfferDataRequirement } from '../../../../types';
import DocumentRequirement from '../../DocumentRequirement/DocumentRequirement';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
const CompanyAccounts = ({ isOptional, isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title="Company accounts"
      documentType="business accounts"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <p>
        Your last set of filed accounts, in a PDF format. This should be the
        full version of the accounts including profit and loss and balance
        sheet, broken down by item.{' '}
        <a
          href="https://effective-accounting.co.uk/blog/what-is-included-in-my-company-accounts/"
          target="_blank"
          rel="noreferrer"
        >
          Learn more
        </a>
      </p>
    </DocumentRequirement>
  );
};

export default CompanyAccounts;
